import React, {useEffect, useState} from 'react';
import ProgressRing from "./ProgressRing";
import {getDays, getDaysHoursMinutesSeconds} from "libs/durations";
import {makeStyles} from "@material-ui/core";
import Typography from "components/BoldTypography";
import GridBlock from "components/GridBlock";

const useStyles = makeStyles((theme) => ({
    titleGrid: {
        marginBottom: theme.spacing(1),
        color: theme.palette.text.primary,
    },
    title: {
        textAlign: "center"
    }
}));

const RingCountdown = (
    {
        duration = 0,
        baseDuration = 0,
        endTimeCallback = () => {
        },
        title,
        width = 120,
        fontSize = '3rem',
    }) => {
    const classes = useStyles();

    const [days, setDays] = useState([0, 0]);
    const [hours, setHours] = useState([0, 0]);
    const [minutes, setMinutes] = useState([0, 0]);
    const [seconds, setSeconds] = useState([0, 0]);

    const [baseDays, setBaseDays] = useState(1);

    const [durationLeft, setDurationLeft] = useState(-1);

    useEffect(() => {
        const arr = getDaysHoursMinutesSeconds(durationLeft);
        setPeriods(arr);
        // eslint-disable-next-line
    }, [durationLeft]);

    const setPeriods = (arr) => {

        const dayPercent = baseDays === 0 ? 0 : Math.floor(arr[0] / baseDays * 100);
        let hourPercent = 100;
        let minutePercent = 100;
        let secondsPercent = 100;

        if (dayPercent === 0) {
            hourPercent = Math.floor(arr[1] / 24 * 100);
            if (hourPercent === 0) {
                minutePercent = Math.floor(arr[2] / 60 * 100);
                if (minutePercent === 0) {
                    secondsPercent = Math.floor(arr[3] / 60 * 100);
                }
            }
        }

        setDays([arr[0], dayPercent]);
        setHours([arr[1], hourPercent]);
        setMinutes([arr[2], minutePercent]);
        setSeconds([arr[3], secondsPercent]);
    }

    useEffect(() => {
            const arr = getDaysHoursMinutesSeconds(duration);
            if (duration <= 0) {
                setPeriods(arr);
                return undefined;
            }

            const baseDays = getDays(baseDuration);
            setBaseDays(baseDays);

            const endTime = Math.floor(new Date().getTime() / 1000) + duration;

            const intervalFunction = (endTime) => () => {
                setDurationLeft((durationLeft) => {
                    const newSeconds = endTime - Math.floor(new Date().getTime() / 1000);
                    if (newSeconds !== durationLeft) {
                        if (durationLeft === 0) {
                            endTimeCallback();
                            clearInterval(interval);
                        }
                        return newSeconds;
                    }
                    return durationLeft;
                })
            }
            const interval = setInterval(intervalFunction(endTime), 200);

            return () => {
                clearInterval(interval);
            }
            // eslint-disable-next-line
        }, [duration, baseDuration]
    )

    return (
        <>
            <GridBlock justify="center" className={classes.titleGrid} itemClassName={classes.title}>
                <Typography>{title}</Typography>
            </GridBlock>
            <GridBlock justify="center">
                <ProgressRing number={days[0]} percent={days[1]} unit='dni' borderWidth={5} width={width} fontSize={fontSize}/>
                <ProgressRing number={hours[0]} percent={hours[1]} unit='h' borderWidth={5} width={width} fontSize={fontSize}/>
                <ProgressRing number={minutes[0]} percent={minutes[1]} unit='min' borderWidth={5} width={width} fontSize={fontSize}/>
                <ProgressRing number={seconds[0]} percent={seconds[1]} unit='sec' borderWidth={5} width={width} fontSize={fontSize}/>
            </GridBlock>

        </>
    );
};

export default RingCountdown;